import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";
import { COUNTRY_LEVEL } from "common/constants";

const SelectCountry = ({
  validation,
  isUpdate,
  selectedId,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.country && validation.errors.country
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.country && validation.errors.country
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {
          level: COUNTRY_LEVEL,
        };

        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [isUpdate, selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="country-field" className="form-label">
        Select Country
      </Label>
      <Select
        name="country"
        id="country"
        value={
          validation?.values?.country?.value
            ? validation?.values?.country
            : null
        }
        placeholder="Select country"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("country", value);
          validation.setFieldError("country", "");
          validation.setFieldValue("adminLevel0.value", null);
          validation.setFieldValue("adminLevel1.value", null);
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getRegions({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  name: {
                    $containsi: inputValue,
                  },
                },
              ],
              $and: [
                {
                  level: COUNTRY_LEVEL,
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.name}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("country", true)}
        className={
          validation.touched.country && validation.errors.country
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.country?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectCountry;
